<template>
  <v-layout class="forgot-password" align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-card class="elevation-3" xs12 sm8 md4>
        <v-layout align-center justify-center>
          <img src="../assets/largeicon.png" alt="logo" class="logo">
        </v-layout>

        <v-card-text>
          <v-form
            ref="form"
            lazy-validation
            >
            <v-text-field prepend-icon="person"
              name="login"
              label="Login"
              type="text"
              v-model="email"
              :rules="[rules.required]"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn block color="primary" @click="forgot()" :disabled="!email"> Request password reset instructions </v-btn>
        </v-card-actions>

        <v-card-text>
          <v-layout row align-center justify-center>
            <v-btn flat color="info" grey-lighten to="/login" > Sign in </v-btn>
          </v-layout>
        </v-card-text>

        <v-alert :value="info" type="info" class="mt-3" > {{ info}} </v-alert>
        <v-alert :value="error" type="warning" class="mt-3" > {{ error }} </v-alert>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import authService from '@/services/authentication'

  export default {
    name: 'forgot_password',

    data () {
      return {
        error: null,
        info: null,
        email: '',
        rules: {
          required: v => !!v || 'Required'
        }
      }
    },

    computed: {
    },

    methods: {
      forgot () {
        if (this.$refs.form.validate()) {
          authService.forgotPassword(
            (data) => {
              this.info = 'Instructions to reset your password have been emailed to you.'
              this.error = null
            },
            (err) => {
              this.info = null
              console.log(err)
              if (err.response) {
                this.error = 'We have encountered a problem while trying to reset your password (' + err.response.statusText + ').'
              } else {
                this.error = 'The system is currently unreachable.'
              }
            },
            this.email
          )
        }
      }
    }
  }
</script>

<style lang="css" scoped>
  .v-btn.v-btn--flat{
    width:100%;
  }
  .v-btn.v-btn--flat:hover:before{
    background-color: #fff;
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.6),0 3px 4px 0 rgba(0,0,0,.48),0 1px 8px 0 rgba(0,0,0,.44);
  }
</style>



// WEBPACK FOOTER //
// src/components/forgot_password.vue